import React from 'react';
import '../App.css';
import { Button, Banner, Card, List, SectionHeader, Footer } from 'design-system-idm';
import IconLocation from '../assests/icon-location.svg';
import IconNotes from '../assests/icon-letter.svg';
import IconTree from '../assests/icon-tree.svg';
import IconSlide from '../assests/icon-slide.svg';
import IconBouy from '../assests/icon-bouy.svg';
import IconMovie from '../assests/icon-movie.svg';
import IconPlant from '../assests/icon-plant.svg';
import TwitterLogo from '../assests/logo-twitter.png';
import FBLogo from '../assests/logo-fb.png';
import InstaLogo from '../assests/logo-insta.png';
import Fountain from '../assests/fountain.png';
import IconImportant from '../assests/icon-important.svg';
import IconX from '../assests/icon-x.svg';

function Home() {
  return (
    <div className="home">
     <Banner
      title="COVID-19 information:"
      IconImportant={IconImportant}
      IconX={IconX}
      BCKGDcolor="#FFD1C2"
      borderBottom="solid 15px #FF6332"
      top="120px"
      >
        The City's Business Activity and Stay at Home Order is in effect until further notice. For the latest information, visit phila.gov/COVID-19. Text COVIDPHL to 888-777 to receive updates to your phone.
      </Banner>
    <div className="wrap">
      <div className="flex mar-bot-3">
          <div className="pad-left width-70 mar-bot-3">
              <h4>Philadelphia</h4>
              <h1>Parks &amp; Recreation</h1>
              <p>Protecting over 10,200 acres of public land and waterways, and managing hundreds of recreation, environmental, and cultural centers.</p>
          </div>
          <img src={Fountain} alt="fountain" className="fountain"></img>
        </div>
      <SectionHeader
      title="Services"
      BCKGDcolor="#8CD9DE"
      ></SectionHeader>
      <div>
      <div className="grid ">
        <Button btnStyle="btn-icon"
        borderBottom="solid 8px #15AF53"
        BCKGDcolor="#F7F7F7">
          <img src={IconNotes}alt="note icon"></img>
          Get a permit for a Parks & Recreation space
        </Button>
        <Button btnStyle="btn-icon"
        borderBottom="solid 8px #15AF53"
        BCKGDcolor="#F7F7F7">
          <img src={IconTree}alt="treee icon" className="icon-location"></img>
          Tree related services
        </Button>
        <Button btnStyle="btn-icon"
        borderBottom="solid 8px #15AF53"
        BCKGDcolor="#F7F7F7">
          <img src={IconSlide}alt="slide icon" className="icon-location"></img>
          Find a park, playground, or recreation center
        </Button>
        <Button btnStyle="btn-icon"
        borderBottom="solid 8px #15AF53"
        BCKGDcolor="#F7F7F7">
          <img src={IconBouy}alt="location icon" className="icon-location"></img>
          Become a lifeguard
        </Button>
        </div>
        <div className="grid">
          <Button btnStyle="btn-icon"
          borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
            <img src={IconLocation}alt="location icon" className="icon-location"></img>
            Find events at Parks & Recreation sites
          </Button>      
          <Button btnStyle="btn-icon"
          borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
            <img src={IconPlant}alt="plant icon" className="icon-location"></img>
            Get organic materials
          </Button>      
          <Button btnStyle="btn-icon"
          borderBottom="solid 8px #15AF53"
          BCKGDcolor="#F7F7F7">
            <img src={IconMovie}alt="movie icon" className="icon-location"></img>
            Apply for a media permit
          </Button>
        </div>
      </div>
      <SectionHeader
      title="What we do"
      BCKGDcolor="#8CD9DE"/>
      <div className="pad-left width-80 mar-bot-3">
      <p>
      Philadelphia Parks & Recreation connects the city’s residents to the natural world, to each other, and to fun physical and social opportunities. We manage historically significant Philadelphia events and special venues, and we work with communities and organizations, leading capital projects and introducing creative programming. 
      </p>
      <p >Philadelphia’s large, diverse parks and recreation system provides something for everyone. Listed below are some of facilities and programs we’re responsible for:
      </p>
      <List
      list={[
        "300+ neighborhood parks, rec centers, and playgrounds",
        "66 miles of trails and 40 historic sites",
        "60 community gardens, farms, and orchards 3 environmental education centers",
        "600+ baseball, softball, football, and soccer fields",
        "74 pools",
        "400+ basketball and 200+ tennis courts",
        "5 ice skating rinks",
        "5 golf courses",
        "25 public computer centers"
      ]}
      />
      </div>
     
      <Card
      title="Weekday Walking Group at Tacony Creek Park"
      subtitle="June 22, 2020 - 9:00 am to 10:00 am"
      sepcolor="#8CD9DE"
      size="card-full"
      layout="col-2"
      dateAddOn="card-date"
      iconAddOn="icon-none"
      dateBCKGDcolor="#15AF53"
      day="22"
      month="June">The FREE walking group with WeWalk PHL will meet Monday and Saturday mornings every week. Join us at two gateways of Tacony Creek park, exercise together and share communal space. RSVP nagiarry@ttfwatershed.org or 215-744-1853. Thankful for this amazing partnership with We Walk PHL, Get Healthy Philly, Philly Powered, Fairmount Park Conservancy, PHL Dept of Public Health, and Philadelphia Parks and Recreation</Card>
      <Card
      title="Weekday Walking Group at Tacony Creek Park"
      subtitle="June 22, 2020 - 9:00 am to 10:00 am"
      sepcolor="#8CD9DE"
      size="card-full"
      layout="col-2"
      dateAddOn="card-date"
      iconAddOn="icon-none"
      dateBCKGDcolor="#15AF53"
      day="29"
      month="June">The FREE walking group with WeWalk PHL will meet Monday and Saturday mornings every week. Join us at two gateways of Tacony Creek park, exercise together and share communal space. RSVP nagiarry@ttfwatershed.org or 215-744-1853. Thankful for this amazing partnership with We Walk PHL, Get Healthy Philly, Philly Powered, Fairmount Park Conservancy, PHL Dept of Public Health, and Philadelphia Parks and Recreation</Card>
      <Card
      title="Little Explorers: Caterpillars, Dragonflies, and Butterflies"
      subtitle="July 1, 2020 - 10:00 am to 11:30 am"
      sepcolor="#8CD9DE"
      size="card-full"
      layout="col-2"
      dateAddOn="card-date"
      iconAddOn="icon-none"
      dateBCKGDcolor="#15AF53"
      day="01"
      month="July">Search for cool bugs in the Garden and make your very own insect sculpture. Designed for toddlers and pre-schoolers, ages 2-4. One adult chaperone is required for every two children. Each session includes activities, performances, snacks, and walks through the garden, weather permitting.</Card>
    <Button BCKGDcolor="#15AF53">See All Events</Button>

</div>

    <Footer
    BCKGDcolorLinks="#15AF53"
    BCKGDcolorContact="#03944f"
    links={[{
        href: "#",
        text: "Documents and forms"
      },{
        href: "#",
        text: "Press Releases"
      },{
        href: "#",
        text: "Rules and regulations"
      },{
        href: "#",
        text: "Fairmount Park Conservancy"
      },{
        href: "#",
        text: "Philadelphia Parks Alliance"
      },
    ]}
    address="1515 Arch Street, Philadelphia, PA 19102"
    email="parksandrecreation@phila.gov"
    phone="(215) 683-3600"
    logoTwitter={TwitterLogo}
    logoFB={FBLogo}
    logoInsta={InstaLogo}
    />
    </div>
  );
}

export default Home;
